import { apiClient } from '@/services/ApiClient.js'

export class GoalService {
  static getGoals(rankId) {
    return apiClient
      .get('ranks/' + rankId + '/goals')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static getGoal(rankId, goalId) {
    return apiClient
      .get('ranks/' + rankId + '/goals/' + goalId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static createGoal(rankId, goal) {
    return apiClient
      .post('ranks/' + rankId + '/goals', goal)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static updateGoal(rankId, goalId, goal) {
    return apiClient
      .patch('ranks/' + rankId + '/goals/' + goalId, goal)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static deleteGoal(rankId, goalId) {
    return apiClient
      .delete('ranks/' + rankId + '/goals/' + goalId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static getRetailers(goalId, query) {
    return apiClient
      .get('goals/' + goalId + '/retailers', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static getRequirements(goalId) {
    return apiClient
      .get('goals/' + goalId + '/requirements')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static createRequirement(goalId, requirement) {
    return apiClient
      .post('goals/' + goalId + '/requirements', requirement)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static deleteRequirement(goalId, requirementId) {
    return apiClient
      .delete('goals/' + goalId + '/requirements/' + requirementId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
